<template>
  <register-result :is-success="true" :description="description" :title="title">
    <div class="information">
      <a-row :gutter="12">
        <a-col :sm="0" :xs="12">现已激活终端：</a-col>
        <a-col :sm="6" :xs="0" class="label">现已激活终端：</a-col>
        <a-col :sm="6" :xs="12" class="ticket">
          {{ total - available }} 台
        </a-col>
        <a-col :sm="0" :xs="12">剩余可用授权：</a-col>
        <a-col :sm="6" :xs="0" class="label">剩余可用授权：</a-col>
        <a-col :sm="6" :xs="12" class="ticket">
          {{ available }} 台
        </a-col>
      </a-row>
    </div>
    <template slot="action">
      <!--<a-button type="primary" @click="scan">扫描二维码</a-button>-->
    </template>
  </register-result>
</template>

<script>
import RegisterResult from './RegisterResult'

export default {
  components: {
    RegisterResult
  },

  props: {
    available: {
      type: Number,
      default: 0
    },

    total: {
      type: Number,
      default: 1
    }
  },

  data () {
    return {
      title: '激活成功',
      description: '您已成功激活这台终端，请不要断开该终端的网络连接，其界面将在若干秒后刷新。'
    }
  },

  methods: {
    scan () {
      this.$emit('onScan')
    }
  }
}
</script>

<style lang="less" scoped>
  .information {
    line-height: 22px;

    .ant-row:not(:last-child) {
      margin-bottom: 24px;
    }

    .label {
      text-align: right;
    }

    .ticket {
      color: #1890ff;
    }
  }
</style>
